import styled from 'styled-components';
import { P, Span } from '@workramp/ui';

export const StyledTitle = styled(P)`
  color: ${({ theme }) => theme.colors.primary[600]};

  em {
    background-color: ${({ theme }) => theme.colors.primary[100]};
  }
`;

export const StyledResultsLength = styled(P)`
  margin-top: ${({ theme }) => theme.spacing(3)}px;
`;

export const StyledSearchResultFooterInfo = styled(Span)`
  color: ${({ theme }) => theme.colors.secondary[600]};
`;
